import React, { useEffect, useRef, useState } from "react";
import TaskCardTemplates from "../../components/template/TaskCardTemplates";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  CHECK_CURRENT_IMAGE_UPLOAD,
  CHECK_NEXT_PAGE,
  MY_COMPLETED_TRANSPORTATION_LIST,
  ONGOING_DETAIL,
  ONGOING_MAP,
  ONGOING_TRANSPORTATIONS,
  TRANSPORTATIONS_PERFORMANCE,
} from "../../common/query-keys";
import {
  CheckListImageType,
  TransportationType,
} from "../../interface/transportation";
import { request } from "../../lib/api";
import styled from "styled-components";
import BackButtonImage from "../../styles/assets/img/back-button.png";
import axios from "axios"; // axios 임포트 추가
import { ReactComponent as IconArrival } from "../../styles/assets/svg/icon_arrival.svg";
import { ReactComponent as IconDeparture } from "../../styles/assets/svg/icon_departure.svg";
import { CheckListLevel, getCheckImageType } from "../../lib/getCheckImageType";
import { ResponseType } from "../../types/response.types";
import { useLocation, useNavigate } from "react-router";
import TransportationCompleteModal from "../../components/molcules/Modal/TransportationCompleteModal";
import AlertModal from "../../components/molcules/Modal/AlertModal";

const MapContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const MapElement = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const OverlayContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: white;
`;

const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 50px;
  height: 50px;
  background: url(${BackButtonImage}) no-repeat center center;
  background-size: cover;
  padding: 10px;
  border: none;
  z-index: 25;
`;

const TaskDetailMainPage = () => {
  /** ============================= state 영역 ============================= */
  const queryClient = useQueryClient();
  const mapElement = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const history = useLocation();

  // 현재 스탭 상태 값 사실상 변수명이 currentLevel이 되어야함
  const [isNextLevel, setIsNextLevel] = useState<number>(1);
  const [isImgCheck, setIsImgCheck] = useState<boolean>(false);
  const [isErrorCheck, setIsErrorCheck] = useState<boolean>(false);
  // * 마지막 단계일 경우 운송완료 모달 출력
  const [isModal, setIsModal] = useState<boolean>(false);
  // * 알림 모달 출력 상태
  const [isAlertModal, setIsAlertModal] = useState<boolean>(false);

  const activeRequest = useRef(false);

  // 추가된 상태들
  const [map, setMap] = useState<any | null>(null);
  const [currentPosition, setCurrentPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [destinationPosition, setDestinationPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  // 상태로 마커와 폴리라인 참조 저장
  const [mapElements, setMapElements] = useState<{
    startMarker?: any;
    endMarker?: any;
    polyline?: any;
  }>({});

  /** ============================= API 영역 ============================= */

  //운송 체크 데이터 전송 함수
  const { mutateAsync: MoveNextStep } = useMutation({
    mutationFn: (data: CheckListImageType[]) => {
      return request({
        method: "POST",
        url: `${CHECK_NEXT_PAGE}/${isNextLevel}`,
        data: data,
      });
    },
    onSuccess: (res: any) => {
      if (res.success) {
        queryClient.invalidateQueries({ queryKey: [ONGOING_TRANSPORTATIONS] });
      }
      queryClient.invalidateQueries({ queryKey: [ONGOING_DETAIL] });
    },
    onError: (error) => {
      console.error("이미지 업로드 및 다음 항목으로 이동 오류: ", error);
      alert("이미지 업로드 및 다음 항목으로 이동에 실패했습니다.");
    },
  });

  //현재 단계의 ( 상차, 하차 완료 이미지 ) 업로드 검사
  const { mutateAsync: onCheckUploaded } = useMutation({
    mutationFn: async (data: any) => {
      const response = await request<ResponseType<any>>({
        method: "GET",
        url: `${CHECK_CURRENT_IMAGE_UPLOAD}`,
        params: data,
      });

      return response.data;
    },
    onSuccess: (res: any) => {
      if (res.success) {
        queryClient.invalidateQueries({ queryKey: [ONGOING_TRANSPORTATIONS] });
      }
      queryClient.invalidateQueries({ queryKey: [ONGOING_DETAIL] });
    },
    onError: (error) => {
      console.error("이미지 업로드 및 다음 항목으로 이동 오류: ", error);
      alert("이미지 업로드 및 다음 항목으로 이동에 실패했습니다.");
    },
  });

  // 진행중인 운송항목 조회
  const {
    data: ongoingTransportData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [ONGOING_TRANSPORTATIONS],
    queryFn: async () => {
      const result = await request<TransportationType[] | any>({
        method: "GET",
        url: ONGOING_TRANSPORTATIONS,
      });
      return result;
    },
  });

  // 현재 운송중인 맵데이터 목적지까지 경로 조회
  const { mutateAsync: getMapData, isPending } = useMutation({
    mutationFn: async (data: any) => {
      const result = await request<any>({
        method: "GET",
        url: `${ONGOING_MAP}`,
        params: data,
      });
      return result.data;
    },
    onSuccess: (res: any) => {
      console.log("res", res);
    },
    onError: (error) => {
      console.error("맵 데이터 조회 오류: ", error);
    },
  });

  /** ============================= 비즈니스 로직 영역 ============================= */

  console.log("ongoingTransportData", ongoingTransportData);
  /** 사진 등록 페이지 이동 */
  const onImageRegisterPageMove = () => {
    navigate("/imgupload", {
      state: {
        transportationId: ongoingTransportData![0].transportation_id,
        isNextLevel: isNextLevel,
      },
    });
  };

  /** 인수증 사진 등록 페이지 이동 */
  const onInvoiceImageRegisterPageMove = () => {
    navigate("/invoice-imgupload", {
      state: {
        transportationId: ongoingTransportData![0].transportation_id,
        isNextLevel: isNextLevel,
      },
    });
  };

  const handleBackButtonClick = () => {
    if (history.pathname !== "/matchListDetail") {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  /** 이전 버튼 클릭 핸들러 (페이지 이전 이동) 페이지만 이동,
   * 상태는 변경 하지 않음
   * 이동시 왕복이 아닌 운송에대한 bottom sheet 모달 이동 처리
   * */
  const handleBackBtnClick = () => {
    //체크리스트 초기화
    setIsImgCheck(false);
    setIsErrorCheck(false);

    if (ongoingTransportData![0].transport_type !== 1 && isNextLevel === 5) {
      setIsNextLevel(2);
      return;
    } else {
      setIsNextLevel((prev: number) => prev - 1);
    }

    refetch();
  };

  console.log(ongoingTransportData?.[0]?.import_export, "ongoingTransportData");
  /** 다음 버튼 클릭 핸들러(데이터 저장, 페이지 다음 이동) */
  const handleNextButtonClick = async () => {
    // 운송 유형 검사 1: 수입, 2: 수출
    const import_export = ongoingTransportData?.[0]?.import_export;
    // 인수증 사진 필수 여부
    const isReceipt: boolean = ongoingTransportData?.[0]?.is_required_receipt;

    /**
     * 다음 페이지로 넘어가기 전에 조건 검사 - 업로드 여부 검사
     * 우선 < 수출 운송[import_export === 2]일 경우만 > 업로드 여부 검사
     */
    if (import_export === 2 && [6].includes(isNextLevel)) {
      /**
       * 업로드 여부 검사
       * @returns boolean
       */
      const isUploaded = await onCheckUploaded({
        transportationId: ongoingTransportData?.[0]?.transportation_id,
        traansportationType: await getCheckImageType(isNextLevel),
      });

      console.log(isUploaded, "isUploaded");
      if (isUploaded) {
      } else {
        setIsAlertModal(true);
        return;
      }
    }

    // 다음 페이지로 이동검증 완료 후 운송 체크 데이터 전송 함수
    await MoveNextStep([
      {
        transportationId: ongoingTransportData![0].transportation_id,
        isImgCompleted: isImgCheck,
        isCompleted: isErrorCheck,
        traansportationType: ongoingTransportData![0].transport_type,
      },
    ]);

    //체크리스트 초기화
    setIsImgCheck(false);
    setIsErrorCheck(false);

    // 마지막 단계일 경우 운송완료 모달 먼저 출력
    if (isNextLevel === 6) {
      setIsModal(true);
      return;
    }

    // 이동시 왕복이 아닌 운송에대한 bottom sheet 모달 이동 처리
    if (ongoingTransportData![0].transport_type !== 1 && isNextLevel === 2) {
      setIsNextLevel(5);
      return;
    } else {
      setIsNextLevel((prev: number) => prev + 1);
    }

    // 전월대비 운송 실적 데이터 초기화
    await queryClient.invalidateQueries({
      queryKey: [TRANSPORTATIONS_PERFORMANCE],
    });
  };

  /** 운송 완료 처리 함수 */
  const handleTransportationComplete = async () => {
    try {
      // 전월대비 운송 실적 데이터 초기화
      await queryClient.invalidateQueries({
        queryKey: [TRANSPORTATIONS_PERFORMANCE],
      });

      // 하단 탭바 내운송정보 데이터 초기화
      await queryClient.invalidateQueries({
        queryKey: ["bottomNavCard"],
      });

      // 모달 닫기
      setIsModal(false);

      // 메인 페이지로 이동
      navigate("/", { replace: true });
    } catch (error) {
      console.error("운송 완료 처리 중 오류:", error);
      alert("운송 완료 처리 중 오류가 발생했습니다.");
    }
  };

  const clearMapElements = () => {
    // 이전 마커와 폴리라인 제거
    mapElements?.startMarker?.setMap(null);
    mapElements?.endMarker?.setMap(null);
    mapElements?.polyline?.setMap(null);

    // 상태 초기화
    setMapElements({});
  };

  /** ============================= useEffect 영역 ============================= */
  useEffect(() => {
    console.log("ongoingTransportData", ongoingTransportData);
    if (ongoingTransportData) {
      // 목적지 위치 설정
      const destinationLat =
        ongoingTransportData[0]?.destination_latitude || 35.1681608;
      const destinationLng =
        ongoingTransportData[0]?.destination_longitude || 129.0573853;

      if (destinationLat && destinationLng) {
        setDestinationPosition({
          lat: destinationLat,
          lng: destinationLng,
        });
      }

      // 상태에 따라 isNextLevel 설정
      if (ongoingTransportData[0]?.status === "EN_ROUTE_TO_LOADING_POINT") {
        setIsNextLevel(1);
      } else if (ongoingTransportData[0]?.status === "LOADING_COMPLETED") {
        setIsNextLevel(2);
      } else if (ongoingTransportData[0]?.status === "EN_ROUTE_TO_WORK_POINT") {
        setIsNextLevel(3);
      } else if (ongoingTransportData[0]?.status === "WORK_COMPLETED") {
        setIsNextLevel(4);
      } else if (
        ongoingTransportData[0]?.status === "EN_ROUTE_TO_UNLOADING_POINT"
      ) {
        setIsNextLevel(5);
      } else if (ongoingTransportData[0]?.status === "UNLOADING_COMPLETED") {
        setIsNextLevel(6);
      }
    }
  }, [ongoingTransportData, !isLoading]);

  // 네이버지도 현재 내위치 표시
  useEffect(() => {
    if (!(window as any).naver?.maps) {
      console.log("네이버 지도 API가 아직 로드되지 않았습니다."); // 디버깅용 로그 추가
      return;
    }

    const initializeMap = async () => {
      try {
        const { naver } = window as any;
        console.log("지도 초기화 시작"); // 디버깅용 로그 추가

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            const currentPos = new naver.maps.LatLng(
              latitude || 37.5666805,
              longitude || 126.9784147
            );

            const mapOptions = {
              center: currentPos,
              zoom: 17,
              zoomControl: true,
              zoomControlOptions: {
                position: naver.maps.Position.TOP_RIGHT,
              },
            };

            if (mapElement.current) {
              const map = new naver.maps.Map(mapElement.current, mapOptions);
              console.log("지도 생성 완료", map); // 디버깅용 로그 추가
              setMap(map);
              setCurrentPosition({
                lat: latitude || 37.5666805,
                lng: longitude || 126.9784147,
              });
            }
          },
          (error) => {
            console.error("Geolocation Error:", error);
            // 위치 정보를 가져올 수 없는 경우 서울 시청을 기본 위치로 설정
            const defaultPos = new naver.maps.LatLng(37.5666805, 126.9784147);
            const mapOptions = {
              center: defaultPos,
              zoom: 17,
              zoomControl: true,
              zoomControlOptions: {
                position: naver.maps.Position.TOP_RIGHT,
              },
            };

            if (mapElement.current) {
              const map = new naver.maps.Map(mapElement.current, mapOptions);
              setMap(map);
              setCurrentPosition({ lat: 37.5666805, lng: 126.9784147 });
            }
          }
        );
      } catch (error) {
        console.error("지도 초기화 중 오류 발생:", error);
      }
    };

    initializeMap();
  }, []);

  useEffect(() => {
    const { naver } = window;
    if (!naver || !map || !currentPosition || !destinationPosition) return;

    const fetchRouteData = async () => {
      if (activeRequest.current) return;
      activeRequest.current = true;

      try {
        clearMapElements();

        const params = {
          startLng: currentPosition.lng || 0,
          startLat: currentPosition.lat || 0,
        };

        const response = await getMapData(params).catch((error) => {
          console.error("맵 데이터 조회 실패:", error);
          // alert("경로 데이터를 가져오는데 실패했습니다.");
          throw error;
        });

        if (!response || !response.mapData || !response.destinationPosition) {
          throw new Error("맵 데이터 형식이 올바르지 않습니다.");
        }

        const { mapData, destinationPosition } = response;

        if (
          !currentPosition.lat ||
          !currentPosition.lng ||
          !destinationPosition.lat ||
          !destinationPosition.lng
        ) {
          throw new Error("좌표 정보가 유효하지 않습니다.");
        }

        const startMarker = new naver.maps.Marker({
          position: new naver.maps.LatLng(
            currentPosition.lat,
            currentPosition.lng
          ),
          map: map,
          icon: {
            url: "/styles/assets/svg/icon_departure.svg",
            size: new naver.maps.Size(30, 40),
            anchor: new naver.maps.Point(15, 40),
          },
        });

        const endMarker = new naver.maps.Marker({
          position: new naver.maps.LatLng(
            destinationPosition.lat,
            destinationPosition.lng
          ),
          map: map,
          icon: {
            url: "/styles/assets/svg/icon_arrival.svg",
            size: new naver.maps.Size(30, 40),
            anchor: new naver.maps.Point(10, 40),
          },
        });

        const path = mapData?.route?.traoptimal[0]?.path;
        if (!path || !Array.isArray(path)) {
          throw new Error("경로 데이터가 없거나 올바르지 않습니다.");
        }

        const linePath = path.map(
          (point: any) => new naver.maps.LatLng(point[1] || 0, point[0] || 0)
        );

        const polyline = new naver.maps.Polyline({
          map: map,
          path: linePath,
          strokeColor: "#5347AA",
          strokeWeight: 5,
        });

        const bounds = new naver.maps.LatLngBounds();
        linePath.forEach((latlng: any) => {
          if (latlng && latlng.lat() && latlng.lng()) {
            bounds.extend(latlng);
          }
        });
        map.fitBounds(bounds);

        setMapElements({ startMarker, endMarker, polyline });
      } catch (error) {
        console.error("경로 API 호출 오류:", error);
        // alert("경로를 표시하는데 실패했습니다. 다시 시도해주세요.");
      } finally {
        activeRequest.current = false;
      }
    };

    fetchRouteData();
  }, [map, currentPosition, destinationPosition, getMapData]);

  useEffect(() => {
    return () => {
      clearMapElements(); // cleanup
    };
  }, [map]);

  /** ============================= 컴포넌트 영역 ============================= */
  return (
    <>
      <MapContainer>
        <BackButton onClick={handleBackButtonClick} />
        <MapElement ref={mapElement} />
        <OverlayContainer>
          <TaskCardTemplates
            ongoingDetailData={
              (ongoingTransportData && ongoingTransportData[0]) || []
            }
            handleNextButtonClick={handleNextButtonClick}
            handleBackBtnClick={handleBackBtnClick}
            isNextLevel={isNextLevel}
            setIsNextLevel={setIsNextLevel}
            setIsImgCheck={setIsImgCheck}
            setIsErrorCheck={setIsErrorCheck}
            isImgCheck={isImgCheck}
            isErrorCheck={isErrorCheck}
            onImageRegisterPageMove={onImageRegisterPageMove}
            onInvoiceImageRegisterPageMove={onInvoiceImageRegisterPageMove}
          />
        </OverlayContainer>
        {isModal && (
          <TransportationCompleteModal
            setIsModal={setIsModal}
            onComplete={handleTransportationComplete}
          />
        )}
        {isAlertModal && (
          <AlertModal
            setIsModal={setIsAlertModal}
            title="알림"
            description={
              <>
                "최소 3장의 사진등록이 필요합니다.
                <br /> ex) 컨테이너사진, 작업사진, 온도사진 등등"
              </>
            }
          />
        )}
      </MapContainer>
    </>
  );
};

export default TaskDetailMainPage;
